"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OutsideClickWrapper = function (_PureComponent) {
  _inherits(OutsideClickWrapper, _PureComponent);

  function OutsideClickWrapper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OutsideClickWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutsideClickWrapper.__proto__ || Object.getPrototypeOf(OutsideClickWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.handleOutsideClick = function (e) {
      var _this$props = _this.props,
          onOutsideClick = _this$props.onOutsideClick,
          shouldOutsideClick = _this$props.shouldOutsideClick;


      if (!_this.wrapper.contains(e.target) && shouldOutsideClick(e)) {
        onOutsideClick(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OutsideClickWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("click", this.handleOutsideClick, this.props.canPropagate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.handleOutsideClick, this.props.canPropagate);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          onOutsideClick = _props.onOutsideClick,
          shouldOutsideClick = _props.shouldOutsideClick,
          canPropagate = _props.canPropagate,
          props = _objectWithoutProperties(_props, ["children", "onOutsideClick", "shouldOutsideClick", "canPropagate"]); // eslint-disable-line


      return _react2.default.createElement(
        "div",
        _extends({ ref: function ref(_ref2) {
            return _this2.wrapper = _ref2;
          } }, props),
        children
      );
    }
  }]);

  return OutsideClickWrapper;
}(_react.PureComponent);

OutsideClickWrapper.propTypes = {
  onOutsideClick: _propTypes2.default.func.isRequired,
  shouldOutsideClick: _propTypes2.default.func,
  children: _propTypes2.default.node,
  /**
   * Determines if the click event listener will allow click events to propagate up the DOM
   */
  canPropagate: _propTypes2.default.bool
};

OutsideClickWrapper.defaultProps = {
  shouldOutsideClick: function shouldOutsideClick() {
    return true;
  },
  canPropagate: true
};

exports.default = OutsideClickWrapper;